import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onLearnMore }) => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-card rounded-xl border border-border overflow-hidden hover:shadow-elevated transition-all duration-300 group">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <div className={`absolute inset-0 ${service?.gradientClass} opacity-10 group-hover:opacity-20 transition-opacity duration-300`} />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-20 h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 bg-card rounded-2xl shadow-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
            <Icon name={service?.icon} size={48} color="var(--color-primary)" strokeWidth={1.5} />
          </div>
        </div>
      </div>
      <div className="p-6 md:p-7 lg:p-8">
        <div className="flex items-start justify-between mb-4">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-headline font-bold text-foreground">
            {service?.title}
          </h3>
          {service?.featured && (
            <span className="px-3 py-1 bg-accent/10 text-accent text-xs font-medium rounded-full whitespace-nowrap">
              {t('services.card.featured')}
            </span>
          )}
        </div>

        <p className="text-sm md:text-base text-muted-foreground mb-6 line-clamp-3">
          {service?.description}
        </p>

        <div className="space-y-3 mb-6">
          {service?.keyFeatures?.slice(0, 3)?.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="mt-1 flex-shrink-0">
                <Icon name="CheckCircle2" size={18} color="var(--color-success)" />
              </div>
              <span className="text-sm text-foreground">{feature}</span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2">
            <Icon name="Clock" size={16} color="var(--color-muted-foreground)" />
            <span className="text-sm text-muted-foreground">{service?.duration}</span>
          </div>
          <Button
            variant="ghost"
            size="sm"
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => onLearnMore(service)}
          >
            {t('services.card.learnMore')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;